import { Navigate } from 'react-router-dom';

import { StrataWorksLogo } from '@/assets/StrataWorksLogo';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuthContext } from '@/contexts/AuthContext';

export default function Auth() {
    const { user, loading, signIn } = useAuthContext();

    if (!loading && user) return <Navigate to='/' replace />;

    return (
        <div className='min-h-screen bg-background flex items-center justify-center p-4'>
            <div className='w-full max-w-md'>
                <div className='flex items-center justify-center gap-3 mb-8'>
                    <StrataWorksLogo className='h-10 w-10' />
                    <div>
                        <h1 className='text-xl font-bold text-foreground'>StrataWorks</h1>
                        <p className='text-xs text-muted-foreground'>Mining Operations Platform</p>
                    </div>
                </div>

                <Card className='bg-card border-border'>
                    <CardHeader>
                        <CardTitle className='text-foreground'>Sign in</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <p className='text-sm text-muted-foreground mb-6'>
                            StrataWorks uses your MinRes account. You'll be redirected to Microsoft
                            to sign in.
                        </p>
                        <Button
                            type='button'
                            className='w-full'
                            onClick={signIn}
                            disabled={loading}
                        >
                            Sign in with Microsoft
                        </Button>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
